import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useGetTripcheckpointMutation, useVehicleDetailsMutation } from "../../api/vmsSlice";
import { useCheckpoints } from "../../services/hooks";
import { toastMessage } from "../../services/functions";
import GoogleMapPreview from "../utils/GoogleMap";
import { Button } from "../utils";
import { buttonClasses } from "../utils/theme";
const defaultCenter = {
	lat: 28.46701,
	lng: 77.5853436,
};

export default function MapView() {
	const location = useLocation();
	const navigate = useNavigate();
    const [trip_Id, setTrip_Id] = useState(null);
	const [selectedVehicle, setSelectedVehicle] = useState(null);
	const factoryCoordinatesValue=location.state?.factoryCoordinatesValue

	const { checkpoints : allCheckpointData, getCheckpoints } = useCheckpoints();
	const [getTripcheckpointTrigger] = useGetTripcheckpointMutation();
	const [vehicleDetailTrigger] = useVehicleDetailsMutation();

	const [vehicledata, setVehicleData] = useState({});
	const [allCheckpointList, setAllCheckpointList] = useState([]);
	const [tripCheckpoints, setTripCheckpoints] = useState([]);

	
    useEffect(() => {
        if (location.state?.selectedVehicle) {
			// console.log('selectedvehicle', location.state?.selectedVehicle)
            setTrip_Id(location.state.selectedVehicle._id);
			setSelectedVehicle(location.state.selectedVehicle)
        } else {
            navigate("/manage-trip"); // Redirect back to the manage-trip page
        }
    }, [location.state, navigate]);
	const generateDetail = (data, checkpointList) => {
		if (!data) return [];
		let lastVisitiedindex = null;
		let tempcheckpoint = [];
		checkpointList?.forEach((ele, index) => {
			const { order, checkpoints = [], optional, visited } = ele;
			if(visited) {
				lastVisitiedindex = index;
			}
			const currentStatus = visited ? data.statusHistory.find((ele, index) => ele.checkpointId === checkpoints[0]._id) : null;
			const previousStatus = checkpointList[index - 1] || null;
			const currentCheckpoint = allCheckpointData?.find((ele, index) => ele._id === checkpoints[0]._id) || {};
			if (currentStatus?.checkpointId) {
				
				tempcheckpoint.push({
					id: index + 1,
					name: currentCheckpoint.displayName || "unNamed",
					optional: false,
					position: {
						lat: currentCheckpoint.latitude || 0,
						lng: currentCheckpoint.longitude || 0,
					},
					details: {
						vehicleNumber: data.vehicleNumber || "-",
						inTime: currentStatus.inTime || "-",
						outTime: currentStatus.outTime || "-",
					},
					visited: visited || false,
				});
			} else {
				if (previousStatus?.visited && checkpoints.length > 1) {
					checkpoints.forEach((el, i) => {
						const currentCheckpoint = allCheckpointData.find((ele, index) => ele._id === el._id);
						if (currentCheckpoint !== undefined) {
							tempcheckpoint.push({
								id: index + 1,
								name: optional ? `${currentCheckpoint.displayName}(optional)` : currentCheckpoint.displayName,
								optional : optional,
								position: {
									lat: currentCheckpoint.latitude,
									lng: currentCheckpoint.longitude,
								},
								details: {
									vehicleNumber: '-',
									inTime:  "-",
									outTime: "-",
								},
								visited: visited || false,
							});
						}
					});
				} else {
					if(currentCheckpoint !== undefined) {
						tempcheckpoint.push({
							id: index + 1,
							name: optional ? `${currentCheckpoint.displayName}(optional)` : currentCheckpoint.displayName,
							position: {
								lat: currentCheckpoint.latitude,
								lng: currentCheckpoint.longitude,
							},
							details: {
								vehicleNumber: '-',
								inTime:  "-",
								outTime: "-",
							},
							visited: visited || false,
						});
					}
				}
			}
		});
		if (lastVisitiedindex !== null) {
			tempcheckpoint.splice(lastVisitiedindex, 0, { ...tempcheckpoint[lastVisitiedindex], lastVisited: true });
		}

		setTripCheckpoints(tempcheckpoint);
	};


	useEffect(()=> {
		if (trip_Id) {
			getTripcheckpointTrigger({ type: "all", tripId: trip_Id })
				.unwrap()
				.then((res) => {
					if (res?.error) {
						toastMessage(false, res.message);
					} else {
						setAllCheckpointList(res?.data || []);
					}
				})
				.catch((err) => {
					console.log("err", err);
				});
			vehicleDetailTrigger({ vehicleEntryId: trip_Id })
				.unwrap()
				.then((res) => {
					setVehicleData(res?.data || {});
				})
				.catch((err) => {
					console.log("err", err);
				});
		}
	}, [trip_Id])
	
	useEffect(()=> {
		if(allCheckpointList.length > 0 && vehicledata.vehicleId) {
		  generateDetail(vehicledata, allCheckpointList);
		}
	},[vehicledata, allCheckpointList]);
	return(
<>
		<div className="trip-route-detail">
			<div className="cust-row" style={{ display: 'flex', justifyContent: 'space-between'}}>
				<div className="cust-col-5">
					<h1 className="title">Trip detail on map</h1>
				</div>
					<div className="cust-col-1 "  style={{ textAlign: 'right' }}>
						{/* <Link className="a_tag_no" to={"/manage-trip"}> */}
							<Button text="Go Back" onClick={()=>navigate('/manage-trip', { state: { selectedVehicle } })} style={buttonClasses.lynkitOrangeEmpty} />
						{/* </Link> */}
					</div>
			</div>
			<hr className="bgg"  style={{marginBottom:'1rem'}}/>
		</div>
		<GoogleMapPreview markerPosition={defaultCenter} tripCheckpoints={tripCheckpoints} factoryCoordinatesValue={factoryCoordinatesValue}/>
	</>
)
	
}
